import { API_BASE_URL } from '@/lib/api';
import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '@/lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

// ============== Admin endpoints (operador) ==============

export const fetchTraceabilities = async ({
  limit = 50,
  offset = 1,
  query = {},
  sort,
} = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/traceability/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const getTraceability = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/traceability/${id}`, {
    headers: withTenant(),
  });
  return res.json();
};

export const getTraceabilityByAirRequest = async (airRequestId) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/by-air-request/${airRequestId}`,
    { headers: withTenant() },
  );
  return res.json();
};

/** Trazabilidad de una solicitud LCL (módulo marítimo). */
export const getTraceabilityByLclRequest = async (lclRequestId) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/by-lcl-request/${lclRequestId}`,
    { headers: withTenant() },
  );
  return res.json();
};

/**
 * Manda al cliente el correo de "solicitud registrada" con su número
 * de seguimiento. Ya no sale automáticamente al crear la solicitud:
 * lo dispara el operador.
 */
export const notifyRequestCreated = async (traceabilityId) => {
  const res = await apiFetch(`${API_BASE_URL}/traceability/${traceabilityId}/notify`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};

/**
 * Crea un hito nuevo en la trazabilidad. El operador lo usa
 * desde el modal "Agregar hito" de la columna de acciones.
 */
export const addStage = async (traceabilityId, dto) => {
  const res = await apiFetch(`${API_BASE_URL}/traceability/${traceabilityId}/stages`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(dto),
  });
  return res.json();
};

/**
 * Actualiza un hito: estado, descripción, nombre, icono.
 */
export const updateStage = async (traceabilityId, stageId, dto) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/${traceabilityId}/stages/${stageId}`,
    {
      method: 'PUT',
      headers: JSON_HEADERS,
      body: JSON.stringify(dto),
    },
  );
  return res.json();
};

/**
 * Elimina un hito (los default quedan como "omitido").
 */
export const removeStage = async (traceabilityId, stageId) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/${traceabilityId}/stages/${stageId}`,
    {
      method: 'DELETE',
      headers: withTenant(),
    },
  );
  return res.json();
};

/**
 * Adjunta un archivo ya subido a R2 a un hito. Devuelve la
 * trazabilidad actualizada.
 */
export const attachFileToStage = async (traceabilityId, stageId, file) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/${traceabilityId}/stages/${stageId}/files`,
    {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(file),
    },
  );
  return res.json();
};

export const detachFileFromStage = async (traceabilityId, stageId, fileKey) => {
  const res = await apiFetch(
    `${API_BASE_URL}/traceability/${traceabilityId}/stages/${stageId}/files/${encodeURIComponent(fileKey)}`,
    {
      method: 'DELETE',
      headers: withTenant(),
    },
  );
  return res.json();
};

// ============== Public endpoint (cliente) ==============

/**
 * Verifica la trazabilidad con NIT + número. Devuelve el DTO
 * público (sin tenantId ni datos sensibles). Sin auth.
 */
export const verifyPublicTraceability = async ({ numero, nit, operador }) => {
  const res = await apiFetch(`${API_BASE_URL}/public/traceability/verify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ numero, nit, ...(operador ? { operador } : {}) }),
  });
  return res.json();
};
